import { render, staticRenderFns } from "./approvedloans.vue?vue&type=template&id=07ae7de8&scoped=true"
import script from "./approvedloans.vue?vue&type=script&lang=js"
export * from "./approvedloans.vue?vue&type=script&lang=js"
import style0 from "./approvedloans.vue?vue&type=style&index=0&id=07ae7de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ae7de8",
  null
  
)

export default component.exports